import { render } from "./AddLabels.vue?vue&type=template&id=c81439e0&scoped=true"
import script from "./AddLabels.vue?vue&type=script&lang=js"
export * from "./AddLabels.vue?vue&type=script&lang=js"

import "./AddLabels.vue?vue&type=style&index=0&id=c81439e0&scoped=true&lang=css"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c81439e0"]])

export default __exports__